import { createAction } from 'deox';
import { ResponseErrors } from 'types';
import { IStripePrice } from './types';

export const setRegisterData = createAction(
  'auth/SET_REGISTER_DATA',
  res => (name: string, value: string) => res({ name, value }),
);

export const setClinicRegisterData = createAction(
  'auth/SET_CLINIC_REGISTER_DATA',
  res => (name: string, value: string) => res({ name, value }),
);

export const prevRegisterStep = createAction('auth/PREV_REGISTER_STEP');
export const nextRegisterStep = createAction('auth/NEXT_REGISTER_STEP');

export const register = {
  request: createAction('auth/REGISTER', resolve => (company: boolean) => resolve(company)),
  success: createAction('auth/REGISTER_SUCCESS', resolve => (payload: Object) => resolve(payload)),
  fail: createAction('auth/REGISTER_FAIL', resolve => (error: ResponseErrors) => resolve(error)),
};

export const login = {
  request: createAction('auth/LOGIN'),
  success: createAction(
    'auth/LOGIN_SUCCESS',
    resolve => ({ access, refresh }: { access: string; refresh: string }) =>
      resolve({ access, refresh }),
  ),
  fail: createAction('auth/LOGIN_FAIL', resolve => (error: ResponseErrors) => resolve(error)),
};

export const getStripePrices = {
  request: createAction('auth/GET_STRIPE_PRICES'),
  success: createAction('auth/GET_STRIPE_PRICES_SUCCESS', resolve => (payload: IStripePrice[]) =>
    resolve(payload),
  ),
  fail: createAction('auth/GET_STRIPE_PRICES_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const setCurrentStripePrice = createAction('auth/SET_CURRENT_STRIPE', res => payload =>
  res(payload),
);

export const setItSystem = createAction('auth/SET_IT_SYSTEM', res => (payload: boolean) =>
  res(payload),
);

export const setBillingType = createAction('auth/SET_BILLING_TYPE', res => (payload: string) =>
  res(payload),
);

export const clearAuthError = createAction('auth/CLEAR_AUTH_ERROR');

export const confirmEmail = {
  request: createAction('auth/CONFIRM_EMAIL', resolve => (payload: string) => resolve(payload)),
  success: createAction('auth/CONFIRM_EMAIL_SUCCESS'),
  fail: createAction('auth/CONFIRM_EMAIL_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const setRefreshToken = createAction('auth/SET_REFRESH_TOKEN', res => (payload: string) =>
  res(payload),
);

export const setAccessToken = createAction('auth/SET_ACCESS_TOKEN', res => (payload: string) =>
  res(payload),
);

export const signupSubClinic = {
  request: createAction('auth/SIGNUP_SUB_CLINIC'),
  success: createAction('auth/SIGNUP_SUB_CLINIC_SUCCESS'),
  fail: createAction('auth/SIGNUP_SUB_CLINIC_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const setAccessTokenForSubClinic = createAction(
  'auth/SET_ACCESS_TOKEN_FOR_SUB_CLINIC',
  res => (payload: string) => res(payload),
);

export const setOpenNewWindows = createAction(
  'auth/SET_OPEN_NEW_WINDOWS',
  res => (payload: boolean) => res(payload),
);

export const forgotPassword = {
  request: createAction('auth/FORGOT_PASSWORD', resolve => (payload: string) => resolve(payload)),
  success: createAction('auth/FORGOT_PASSWORD_SUCCESS'),
  fail: createAction('auth/FORGOT_PASSWORD_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const createNewPassword = {
  request: createAction(
    'auth/CREATE_NEW_PASSWORD',
    resolve => (token: string, password: string, confirmPassword: string) =>
      resolve({ token, password, confirmPassword }),
  ),
  success: createAction('auth/CREATE_NEW_PASSWORD_SUCCESS'),
  fail: createAction('auth/CREATE_NEW_PASSWORD_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const setTemporary = createAction(
  'auth/SET_TEMPORARY',
  res => (payload: boolean) => res(payload),
);
